/* eslint-disable react-hooks/exhaustive-deps */
import "../../Business_detail/Business_detail.css";
import "swiper/css";
import "swiper/css/pagination";

import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

import PageHeader from "../../../page-header/PageHeader";
import Preloader from "../../../Preloader";
import axios, { API_URI } from "../../../../axios";

const PassengersRoutes = () => {
  const { t } = useTranslation();
  const { language } = i18next;

  const [activeTab, setActiveTab] = React.useState("international");

  const [scheduleInt, setScheduleInt] = React.useState([]);
  const [scheduleDom, setScheduleDom] = React.useState([]);

  const [loadingInt, setLoadingInt] = React.useState(true);
  const [loadingDom, setLoadingDom] = React.useState(true);

  const convertTimeFormat = (timeStr) => {
    if (!timeStr) return "";
    const [hours, minutes] = timeStr.split(":");
    return `${hours}:${minutes}`;
  };

  React.useEffect(() => {
    (async () => {
      setLoadingInt(true);

      try {
        const req = await axios.get(`/${language}/api/schedule-international`);
        setScheduleInt(req.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingInt(false);
      }
    })();
  }, [language]);

  React.useEffect(() => {
    (async () => {
      setLoadingDom(true);

      try {
        const req = await axios.get(`/${language}/api/schedule-domestic`);
        setScheduleDom(req.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingDom(false);
      }
    })();
  }, [language]);

  const currentSchedule =
    activeTab === "international" ? scheduleInt : scheduleDom;

  const currentLoading =
    activeTab === "international" ? loadingInt : loadingDom;

  const renderScheduleTable = (results = []) => {
    if (results.length === 0) return null;

    return (
      <div className="container mx-auto max-h-[32rem] overflow-auto">
        <table className="w-full border-collapse">
          <thead className="sticky top-0 z-10">
            <tr>
              <td className="bg-[#BFBFBF] p-4">{t("airline")}</td>
              <td className="bg-[#BFBFBF] p-4">{t("translation:flights")}</td>
              <td className="bg-[#BFBFBF] p-4">
                {t("translation:transitNumber")}
              </td>
              <td className="bg-[#BFBFBF] p-4">
                {t("translation:flightsDays")}
              </td>
              <td className="bg-[#BFBFBF] p-4">
                {t("translation:flightTime")}
              </td>
              <td className="bg-[#BFBFBF] p-4">
                {t("translation:landignTime")}
              </td>
            </tr>
          </thead>

          <tbody>
            {results.map((item, i) => {
              const isOdd = i % 2 !== 0;
              const bgClass = isOdd ? "bg-[#F1F1F1]" : "bg-white";

              return (
                <tr key={item.id || `${item.flight_number}-${i}`}>
                  <td className={`p-4 ${bgClass}`}>
                    {item.airline?.logo && (
                      <img
                        src={`${API_URI}${item.airline.logo}`}
                        className="w-[120px] h-[48px] object-contain"
                        alt={item.airline?.name || ""}
                      />
                    )}
                  </td>

                  <td className={`p-4 text-[18px] ${bgClass}`}>
                    {item.origin_city} - {item.destination_city}
                  </td>

                  <td className={`p-4 text-[18px] ${bgClass}`}>
                    {item.flight_number}
                  </td>

                  <td className={`p-4 text-[18px] ${bgClass}`}>
                    {(item.departure_days || []).join(" ")}
                  </td>

                  <td className={`p-4 text-[18px] ${bgClass}`}>
                    {convertTimeFormat(item.departure_time)}
                  </td>

                  <td className={`p-4 text-[18px] ${bgClass}`}>
                    {convertTimeFormat(item.arrival_time)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>{`${t("business")} - ${t(
          "Ashgabat_International_Airport",
        )}`}</title>
      </Helmet>

      <div className="news-details">
        <PageHeader
          title={t("translation:passengersRoute")}
          breadCrumbItems={[
            { label: t("home"), path: "/" },
            { label: t("passengers"), path: "/passengers" },
            {
              label: t("translation:passengersRoute"),
              path: "/passengers/routes-and-chedules",
            },
          ]}
        />

        <div className="container py-12">
          <div className="mb-8 flex justify-center gap-4">
            <button
              type="button"
              onClick={() => setActiveTab("domestic")}
              className={`px-6 py-3 rounded-md transition ${
                activeTab === "domestic"
                  ? "bg-[#0A940B] text-white"
                  : "bg-[#F1F1F1] text-black"
              }`}
            >
              {t("translation:inside") || "Domestic"}
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("international")}
              className={`px-6 py-3 rounded-md transition ${
                activeTab === "international"
                  ? "bg-[#0A940B] text-white"
                  : "bg-[#F1F1F1] text-black"
              }`}
            >
              {t("translation:outside") || "International"}
            </button>
          </div>

          {currentLoading ? (
            <Preloader />
          ) : currentSchedule.length === 0 ? (
            <p className="py-10 text-center text-[18px]">
              {t("translation:noData") || "No data"}
            </p>
          ) : (
            <div className="space-y-10">
              {currentSchedule.map((section, index) => (
                <div
                  key={`${section.title}-${index}`}
                  className="py-6 bg-white"
                  style={{
                    boxShadow: "0px 4px 9.7px 0px #00000026",
                  }}
                >
                  <div className="w-[70%] mx-auto mb-5">
                    <p className="text-[24px] text-center leading-[31.4px]">
                      {section.title}
                    </p>
                  </div>

                  {renderScheduleTable(section.results || [])}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PassengersRoutes;
